export default "__VITE_ASSET__BYBtYwIu__"